import React, { useContext, useState} from 'react';
import {
  Menu,
  Input,
  Dropdown,
  Grid,
  GridColumn,
  GridRow,
  DropdownMenu,
  DropdownItem,
  Button,
} from 'semantic-ui-react';
import { RootStoreContext } from '../../../App/stores/RootStore';
import { observer } from 'mobx-react-lite';
import msalContext from "../../../App/api/msalAuth";

//TODO: Replace hard-coded dropdown values
const statusList = [
  {
    key:1,
    text: 'Pending Recommendation',
    value: 'Pending Recommendation'
  },
  {
    key:2,
    text: 'Under Recommendation Review',
    value: 'Under Recommendation Review'
  },
  {
    key:3,
    text: 'Pending Decision',
    value: 'Pending Decision'
  },
  {
    key:4,
    text: 'Under Decision Review',
    value: 'Under Decision Review'
  },
  {
    key:5,
    text: 'Pending Additional Review',
    value: 'Pending Additional Review'
  },
  {
    key:6,
    text: 'Under Additional Review',
    value: 'Under Additional Review'
  },
  {
    key:7,
    text: 'Review Closed',
    value: 'Review Closed'
  }
]
const serviceTypeList = [
  {

    key:1,
    text: 'VRS',
    value: 'VRS'
  },
  {
    key:2,
    text: 'IPCTS',
    value: 'IPCTS'
  }
]
const transactionTypeList = [
  {
    key:1,
    text: 'ConsumerRegistration',
    value: 'ConsumerRegistration'
  },
  {
    key:2,
    text: 'ConsumerUpdate',
    value: 'ConsumerUpdate'
  },
  {
    key:3,
    text: 'ServicePort',
    value: 'ServicePort'
  }
]
const RequestFilters = () => {
  const rootStore = useContext(RootStoreContext);
  const { predicate, setPredicate, clearPredicates } = rootStore.requestStore;
  // const { user } = rootStore.userStore;
  const [caseId, setCaseId] = useState('')
  const [regId, setRegId] = useState('')
  const [serviceId, setServiceId] = useState('')
  const [provider, setProvider] = useState('')
  const [status, setStatus] = useState('')
  const [serviceType, setServiceType] = useState('')
  const [transactionType, setTransactionType] = useState('')
  const [currentReviewer, setCurrentReviewer] = useState('')

  const account = msalContext.getActiveAccount();
  const ClearState = ()=>{

    setCaseId("")
    setRegId("")
    setServiceId("")
    setProvider("")

    setStatus("")
    setServiceType("")
    setTransactionType("")
    setCurrentReviewer("")
    clearPredicates()
  }

  const quickFilters:string[] = ["OpenRequests", "all", "IsSpanish", "ReviewerById"]
  const UpdateFilter = async (pred:string, val:string)=>{
    if(quickFilters.includes(pred)){
      ClearState()
    }
    await setPredicate(pred, val)
  }

  return (
    <Grid>
      <GridRow columns={5} textAlign='justified'>
        <GridColumn>
          <Input label="Case ID" placeholder='Search...'
                 onChange={async (x) => {
                   setCaseId(x.target.value.toString())
                   await UpdateFilter('RequestCaseID', x.target.value.toString())}}
                 value={caseId} />
        </GridColumn>
        <GridColumn>
          <Input label="Registration ID" placeholder='Search...'
                 onChange={async (x) => {
                   setRegId(x.target.value.toString())
                   await UpdateFilter('registrationRequestID', x.target.value.toString())}}
                 value={regId} />
        </GridColumn>
        <GridColumn>
          <Input label="Service Id" placeholder='Search...'
                 onChange={async (x) => {
                   setServiceId(x.target.value.toString())
                   await UpdateFilter('tdn', x.target.value.toString())}}
                 value={serviceId} />
        </GridColumn>
        <GridColumn>
          <Input label="Provider" placeholder='Search...'
                 onChange={async (x) => {
                   setProvider(x.target.value.toString())
                   await UpdateFilter('provider', x.target.value.toString())}}
                 value={provider} />
        </GridColumn>
        <GridColumn>
          <Input label="Current Reviewer" placeholder='Search...'
                 onChange={async (x) => {
                   setCurrentReviewer(x.target.value.toString())
                   await UpdateFilter('CurrentReviewer', x.target.value.toString())}}
                 value={currentReviewer} />
        </GridColumn>
      </GridRow>
      <GridRow columns={5} textAlign='justified'>
        <GridColumn>
          <Dropdown
              placeholder='Status...'
              clearable={true}
              fluid
              selection
              options={statusList}
              onChange={async (x,d) => {
                setStatus(d.value as string)
                await UpdateFilter('Status', d.value as string)}}
              value={status}
          />
        </GridColumn>
        <GridColumn>
          <Dropdown
              placeholder='Service Type...'
              clearable={true}
              fluid
              selection
              options={serviceTypeList}
              onChange={async (x, d) => {
                setServiceType(d.value as string)
                await UpdateFilter('serviceType', d.value as string)}}
              value={serviceType}
          />
        </GridColumn>
        <GridColumn>
          <Dropdown
              placeholder='Transaction Type...'
              clearable={true}
              fluid
              selection
              options={transactionTypeList}

              onChange={async (x,d) => {
                setTransactionType(d.value as string)
                await UpdateFilter('TransactionType', d.value as string)}}
              value={transactionType}

          />
        </GridColumn>
        <GridColumn>
          <Menu vertical>
            {/*<Header icon={'filter'} attached color={'teal'} content={'Quick Filters'} />*/}
            <Dropdown item color={'teal'} icon={'filter'} text='Quick Filters'>
              <DropdownMenu>

                <DropdownItem active={predicate.has('ReviewerById')}
                              onClick={() => UpdateFilter('ReviewerById', account?.localAccountId??'')}
                              color={'blue'} >My Requests</DropdownItem>
                <DropdownItem active={predicate.has('OpenRequests')}
                              onClick={() => UpdateFilter('OpenRequests', 'true')}
                              color={'blue'} >Open Requests</DropdownItem>
                <DropdownItem active={predicate.has('IsSpanish')}
                              onClick={() => UpdateFilter('IsSpanish', 'true')}
                              color={'blue'} >Open Spanish Requests</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Menu>
        </GridColumn>
        <GridColumn>
          <Button onClick={() => UpdateFilter('all', 'true')}
                  color={'blue'} >Clear Filters</Button>
        </GridColumn>
      </GridRow>
    </Grid>
  )
}

export default observer(RequestFilters);